<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dense flat color="secondary">
        <v-toolbar-title>Stock Transfer Records</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text color="accent" @click.native="pendingDialog = true">
          <v-badge color="red" :content="`${pendingTransfers.length}`"
            >All Pending Transfers
          </v-badge>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" xs="12" sm="4" md="4">
            <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  dense
                  outlined
                  single-line
                  v-model="StartDate"
                  label="From"
                  prepend-icon="mdi-calendar-month"
                  v-on="on"
                  readonly
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="StartDate"
                @input="menu1 = false"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <!-- datepicker 2 -->
          <v-col cols="12" xs="12" sm="4" md="4">
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  dense
                  outlined
                  single-line
                  v-model="EndDate"
                  label="To"
                  prepend-icon="mdi-calendar-month"
                  v-on="on"
                  readonly
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="EndDate"
                @input="menu2 = false"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" xs="12" sm="4" md="4">
            <v-autocomplete
              name="transferPickedBy"
              dense
              outlined
              v-model="PickedBy"
              :items="users"
              label="Picked By"
              item-text="name"
              item-value="id"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" xs="12" sm="4" md="4">
            <v-btn color="accent" @click="getRecords" :loading="loader"
              >Query Data</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field v-model="search" outlined dense></v-text-field>
            <!-- start of table -->
            <v-data-table
              :mobile-breakpoint="0"
              :items-per-page="pageItems"
              :headers="headers"
              :items="stockTransfers"
              :search="search"
            >
              <!-- template -->
              <!-- <template v-slot:item.Price="{ item }">
            {{ item.Price.toLocaleString() }}
          </template>-->
              <!-- end -->
              <!-- template -->
              <template v-slot:item.received="{ item }">
                <span
                  style="color: green; font-weight: bold"
                  v-if="item.received == 'Y'"
                  >Received</span
                >
                <span
                  style="color: red; font-weight: bold"
                  v-if="item.received == 'N'"
                  >Not Received Yet</span
                >
                <!-- <span
                  style="color: red; font-weight: bold"
                  v-if="item.received == 'N' && activeStore != item.ToStrCode"
                  >Not Received Yet</span
                > -->
                <!-- <v-btn
                  style="margin-left: -20px"
                  v-if="item.received == 'N' && activeStore == item.ToStrCode"
                  text
                  color="accent"
                  @click="openTransferDialog(item)"
                  >Accept Transfer<v-icon right>mdi-check</v-icon></v-btn
                > -->
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
        <!-- snackbar -->

        <!-- Acceptance dialog -->
        <v-dialog v-model="acceptDialog" max-width="750px">
          <v-card>
            <v-toolbar dense color="accent" dark>
              <v-toolbar-title>Receive Transferred Item</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click.native="acceptDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container fluid class="subtitle-2 text--primary">
                <v-row class="subtitle-2 text--primary">
                  <v-col cols="12" xs="12" md="12">
                    Product:
                    {{ transferItem.product && transferItem.product.Name }}
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" xs="12" md="6">
                    Quantity: {{ transferItem.Quantity }}
                  </v-col>

                  <v-col cols="12" xs="12" md="6">
                    From:
                    {{ transferItem.fromstore && transferItem.fromstore.Name }}
                  </v-col>

                  <v-col cols="12">
                    <v-btn
                      color="primary"
                      @click="receiveStock"
                      :loading="loader"
                    >
                      <v-icon left>mdi-content-save</v-icon> Receive Now
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- end of acceptance modal-->

        <!-- summary dialog -->
        <v-dialog
          v-model="pendingDialog"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
        >
          <v-card>
            <v-toolbar dark color="accent">
              <v-toolbar-title>
                <v-btn icon dark @click.native="pendingDialog = false">
                  <v-icon dark>mdi-keyboard-backspace</v-icon>
                </v-btn>
                Pending Transfers
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon dark @click.native="pendingDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>

            <v-card-text>
              <v-container>
                <v-row justify="center">
                  <v-col cols="12" xs="12" md="10">
                    <v-data-table
                      :mobile-breakpoint="0"
                      :items-per-page="200"
                      :headers="headers"
                      :items="pendingTransfers"
                      :search="search"
                      show-select
                      v-model="selectedTransfers"
                    >
                      <!-- <template v-slot:item.received="{ item }">
                        <v-btn
                          style="margin-left: -20px"
                          v-if="
                            item.received == 'N' &&
                            activeStore == item.ToStrCode
                          "
                          text
                          color="accent"
                          @click="openTransferDialog(item)"
                          >Accept Transfer<v-icon right
                            >mdi-check</v-icon
                          ></v-btn
                        >
                      </template> -->
                    </v-data-table>
                  </v-col>

                  <v-col cols="10">
                    <v-btn color="primary" class="float-right" :loading="loader" @click="receiveStock">Receive Stock</v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- end -->
        <snackbar ref="snackbar"></snackbar>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      record: {},
      acceptDialog: false,
      pendingDialog: false,
      transferItem: {},
      selectedTransfers: [],
      search: null,
      pageItems: 100,
      FromStore: null,
      menu1: false,
      menu2: false,
      StartDate: null,
      EndDate: null,
      ToStore: null,
      PickedBy: null,
      loader: false,
      stores: [],
      users: [],
      headers: [
        { text: "Product", value: "product.Name" },
        { text: "Ref No./ IMEI", value: "ref1" },
        { text: "Quantity", value: "Quantity" },
        { text: "Unit", value: "uomentry.UomName" },
        { text: "From Shop", value: "fromstore.Name" },
        { text: "To Store", value: "tostore.Name" },
        { text: "Picked By", value: "pickedby.name" },
        { text: "Date of Transfer", value: "DocDate" },
        // { text: "Status", value: "received" },
      ],
      stockTransfers: [],
      pendingTransfers: [],
    };
  },
  computed: {
    activeStore() {
      return localStorage.getItem("store_id");
    },
    totalSalesValue() {
      let total = 0;
      if (this.totalSales) {
        total = this.totalSales.toLocaleString();
      }
      return total;
    },
  },
  methods: {
    openTransferDialog(data) {
      this.transferItem = data;
      this.acceptDialog = true;
    },
    receiveStock() {
      const selectedTransfers = this.selectedTransfers;
      // loop through and create an array of ids
      const ids = [];
      selectedTransfers.forEach((item) => {
        ids.push(item.id);
      });

      if(ids.length <= 0) {
        this.$refs.snackbar.show("Please select at least one transfer", "red");
        return;
      } 

      const data = {
        receivedIds: ids,
      };

      const self = this;

      self.loader = true;
      const url = `/receive-stock-transfer-web`;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            self.getPendingTransfers();
            if(self.pendingTransfers.length <= 0) {
              location.reload();
            }
          } else {
            self.loader = false;
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          self.loader = false;
          this.$refs.snackbar.show(err, "red");
        });
    },
    getRecords() {
      const self = this;
      const data = {
        StartDate: self.StartDate,
        EndDate: self.EndDate,
        FromStore: null,
        ToStore: null,
        PickedBy: self.PickedBy,
      };

      self.loader = true;
      const url = `/stock-transfer-report`;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            self.stockTransfers = res.ResponseData.AllTransfers;
          } else {
            self.loader = false;
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getPendingTransfers() {
      const self = this;
      self.loader = true;
      const url = `/pending-stock-transfers`;
      this.$store
        .dispatch("get", url)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            self.pendingTransfers = res.ResponseData;
          } else {
            self.loader = false;
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getStores() {
      const self = this;
      this.$store
        .dispatch("get", `/stores`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getUsers() {
      const self = this;
      this.$store
        .dispatch("get", `/users`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.users = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    Promise.all([
      this.getRecords(),
      this.getStores(),
      this.getUsers(),
      this.getPendingTransfers(),
    ]);
  },
};
</script>

<style lang="scss" scoped>
</style>